/**
 * Protected route component for admin-only pages
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAdmin } from '../../contexts/AdminContext';

const AdminRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, loading: adminLoading } = useAdmin();

  // Show loading while checking authentication and admin status
  if (authLoading || adminLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Show access denied if not admin
  if (!isAdmin) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        maxWidth: '500px',
        margin: '2rem auto'
      }}>
        <h2>Access Denied</h2>
        <p>You need administrator privileges to access this page.</p>
        <p>Please contact your system administrator if you believe this is an error.</p>
        <button
          onClick={() => window.history.back()}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  // Render admin content if user is authenticated and is admin
  return children;
};

export default AdminRoute;